import React from 'react';
import Icon from '../../design-system/icon.jsx';

export const FreeShipping = () => (
  <div className="cart-popup__free-shipping">
    <Icon type="shipping-truck" />
    <span>Free U.S Shipping</span>
  </div>
);
